module.exports = __webpack_public_path__ + "static/media/img_7.6be09a27.png";